import FileIcon from "components/Icons/FileIcon";
import GroupsIcon from "components/Icons/GroupsIcon";
import BasicTimerIcon from "components/Icons/BasicTimerIcon";
import ChartIcon from "components/Icons/ChartIcon";
import type { UpsellPageContent } from "../Upsell.types";
import UpsellPageLayout from "../components/UpsellPageLayout";
import videos from "config/videos";

/** Static, so it lives at module scope rather than behind an empty-dep `useMemo`. */
const CONTENT: UpsellPageContent = {
  feature: "GroupsAndMonitoring",
  eyebrow: "upsell.groups_and_monitoring_nav_label",
  heading: "upsell.groups_and_monitoring_heading",
  subheading: "upsell.groups_and_monitoring_subheading",
  bannerPrompt: "upsell.groups_and_monitoring_banner_prompt",
  ctaHeading: "upsell.groups_and_monitoring_cta_heading",
  ctaDescription: "upsell.request_access_cta_description",
  video: videos.groupsAndMonitoring,
  cards: [
    {
      icon: FileIcon,
      title: "upsell.groups_and_monitoring_card_dashboards_title",
      description: "upsell.groups_and_monitoring_card_dashboards_description",
    },
    {
      icon: GroupsIcon,
      title: "upsell.groups_and_monitoring_card_groups_title",
      description: "upsell.groups_and_monitoring_card_groups_description",
    },
    {
      icon: BasicTimerIcon,
      title: "upsell.groups_and_monitoring_card_objective_title",
      description: "upsell.groups_and_monitoring_card_objective_description",
    },
    {
      icon: ChartIcon,
      title: "upsell.groups_and_monitoring_card_leaderboards_title",
      description: "upsell.groups_and_monitoring_card_leaderboards_description",
    },
  ],
};

function UpsellGroupsAndMonitoring() {
  return <UpsellPageLayout content={CONTENT} />;
}

export default UpsellGroupsAndMonitoring;
